var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_103","data-name":"Group 103","transform":"translate(1 1.414)"},[React.createElement("path",{"id":"Path_121","data-name":"Path 121","d":"M7.5,18H37.444","transform":"translate(-7.5 -3.028)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_122","data-name":"Path 122","d":"M18,7.5,32.972,22.472,18,37.444","transform":"translate(-3.028 -7.5)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

ArrowRight.defaultProps = {"width":"31.944","height":"32.773","viewBox":"0 0 31.944 32.773"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
